import React from 'react'

import PopoverMenu from "../../popover-menu/popover-menu/popover-menu"
import {MenuOption} from "../../popover-menu/popover-menu/const"
import {EntitySelectorEntityType} from "../../entity-selector/@const"

// What an add trigger hands back: the Entity Selector tab to open on.
export type RelatedItemAddHandler = {(entityType: EntitySelectorEntityType): void}

// popoverClass of this menu. An add trigger that lives INSIDE another popover
// has to list it in that popover's outsideClickIgnoreClasses -- Popover tethers
// its content to the body, so a click in here reads as a click outside the host
// popover and would unmount this menu before the click landed.
export const RELATED_ITEMS_ADD_POPOVER_CLASS = 'gd-related-items-add-popover'

// The type to link BEFORE the selector opens, so nobody lands on the Task tab
// only to go looking for Documents. The modal keeps every tab switchable -- this
// only picks the starting one.
export function getRelatedItemAddOptions(onAdd: RelatedItemAddHandler): MenuOption[] {
    return [
        {
            icon    : 'i5-task',
            label   : 'Task',
            onClick : () => onAdd(EntitySelectorEntityType.TASK),
        },
        {
            icon    : 'i5-project',
            label   : 'Project',
            onClick : () => onAdd(EntitySelectorEntityType.PROJECT),
        },
        {
            icon    : 'i5-task-list',
            label   : 'Document',
            onClick : () => onAdd(EntitySelectorEntityType.DOCUMENT),
        },
        {
            icon    : 'i5-meeting',
            label   : 'Meeting',
            onClick : () => onAdd(EntitySelectorEntityType.MEETING),
        },
    ]
}

type Props = {
    menuParams  : {onAdd: RelatedItemAddHandler}
    hidePopover : callback
}

// The same options as a PopupMenuButton `menuComponent`, for the triggers that
// are NOT already a menu row (the add link, the "+" button, the glist hosts'
// button). A trigger that IS a row -- the task view toolbar's "Related item" --
// uses getRelatedItemAddOptions with PopoverMenuItemType.SUBMENU instead.
export default function RelatedItemAddMenu(props: Props) {

    return (
        <PopoverMenu className   = "min-w-180"
                     options     = {getRelatedItemAddOptions(props.menuParams.onAdd)}
                     hidePopover = {props.hidePopover}/>
    )
}
